// removed by extract-text-webpack-plugin
module.exports = {"sec":"MyPackage__sec__RVwBH9Zu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MyPackage/MyPackage.scss
// module id = XnEg
// module chunks = 0